module.exports = __webpack_public_path__ + "static/media/conversation.c697ee11.svg";